export default {"src":"/_next/static/image/public/images/flags/flag_501.df4250be1021dd1d80b2bf289ccf2038.svg","height":16,"width":25};